import { isUndefined } from 'lodash-es';

import { safeGet } from '../../../../core/utils/safe-get.js';
import type { AxisIdToScales } from '../../../context/XYChartScales.context.js';
import type { XYChartAxisInternal } from '../../../types/xy-chart-internals.js';
import {
  isInfiniteZoomEnabledFor,
  isZoomEnabledFor,
} from '../../../utils/axis-interactions.js';

const LEFT = 0;
const RIGHT = 1;

function checkInfiniteAxisBoundaries(
  axis: XYChartAxisInternal,
  scales: AxisIdToScales,
  axes: XYChartAxisInternal[],
) {
  const otherNonInfiniteAxes = axes.filter(
    (_axis) =>
      _axis.id !== axis.id &&
      isZoomEnabledFor(_axis) &&
      !isInfiniteZoomEnabledFor(_axis),
  );

  let canPanLeft = true;
  let canPanRight = true;

  otherNonInfiniteAxes.forEach((_axis) => {
    const { initialScale, currentScale } = safeGet(scales, _axis.id);
    const [initialMin, initialMax] = initialScale.domain();
    const [currentMin, currentMax] = currentScale.domain();

    const atLeftBoundary = currentMin.valueOf() === initialMin.valueOf();
    const atRightBoundary = currentMax.valueOf() === initialMax.valueOf();

    if (atLeftBoundary) {
      canPanLeft = false;
    }

    if (atRightBoundary) {
      canPanRight = false;
    }
  });

  return [canPanLeft, canPanRight];
}

export function getVisibleArrows(
  visibleAxis: XYChartAxisInternal,
  scales: AxisIdToScales,
  axes: XYChartAxisInternal[],
) {
  const { currentScale, initialScale } = safeGet(scales, visibleAxis.id);

  const [currentMin, currentMax] = currentScale.domain();
  const [initialMin, initialMax] = initialScale.domain();

  if (
    isUndefined(currentMin) ||
    isUndefined(currentMax) ||
    isUndefined(initialMin) ||
    isUndefined(initialMax)
  ) {
    return [false, false];
  }

  let leftArrow =
    currentScale.domain()[LEFT].valueOf() !==
    initialScale.domain()[LEFT].valueOf();

  let rightArrow =
    currentScale.domain()[RIGHT].valueOf() !==
    initialScale.domain()[RIGHT].valueOf();

  if (visibleAxis.interactions.infinite === true) {
    const [canPanLeft, canPanRight] = checkInfiniteAxisBoundaries(
      visibleAxis,
      scales,
      axes,
    );
    leftArrow = canPanLeft;
    rightArrow = canPanRight;
  }

  return [leftArrow, rightArrow];
}
